module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-600italic.woff2?cc4bf5b2955147801c024b2b118f4a5c";